// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Lightning(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Lightning" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M10.75 1.5L4.5 12L9.73024 12L5.12411 22.5L19.5 8.50003L13.0163 8.49997L18.25 1.5H10.75Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Lightning.js.map